import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { DialogRef } from '@ngneat/dialog';
import { ContentPipe } from 'src/app/services/content/content.pipe';
import { ContentPipeModule } from 'src/app/services/content/content-pipe.module';
import { MineButtonPrimaryComponent } from '../mine-button-primary/mine-button-primary.component';
import { MineXButtonComponent } from '../mine-x-button/mine-x-button.component';
import { SafePipe } from '../pipes/safe.pipe';
import { GenericSection } from '../models/generic-section.interface';
import { ChatService } from 'src/app/chat/chat.service';
@Component({
  selector: 'upgrade-plan-section',
  templateUrl: './upgrade-plan-section.component.html',
  styleUrls: ['./upgrade-plan-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContentPipeModule, MineXButtonComponent, MineButtonPrimaryComponent, SafePipe]
})
export class UpgradePlanSectionComponent implements OnInit {
  private readonly contentPipe = inject(ContentPipe);
  private readonly dialogRef = inject(DialogRef<GenericSection>, { optional: true });
  private readonly chatService = inject(ChatService);
  title: string = this.contentPipe.transform('common.upgradeYourPlan');
  text: string = '';

  ngOnInit(): void {
    if (this.dialogRef?.data) {
      this.title = this.dialogRef.data.title;
      this.text = this.dialogRef.data.text;
    }
  }

  upgradePlan(): void {
    this.chatService.show();
    this.dialogRef?.close(true);
  }

  closeDialog(): void {
    this.dialogRef?.close(false);
  }
}
